import { fetchAuthSession } from 'aws-amplify/auth';
import AWS from 'aws-sdk';

 // Initialize AWS Cognito Identity pool or STS with the provided auth token
 const initAWSTemporaryCredentials = async (): Promise<AWS.CognitoIdentityCredentials> => {
    try {
      // Fetch session and tokens
      const { tokens } = await fetchAuthSession();
      
      // Ensure we are using the ID token for authentication
      const idToken = tokens?.idToken?.toString(); 
      
      if (!idToken) {
        throw new Error('Invalid ID token');
      }
  
      // Initialize Cognito credentials
      const credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'ap-southeast-2:7819ca54-270c-45db-93f1-0d9f1e89afb8', // Replace with your actual Cognito Identity Pool ID
        Logins: {
          'cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_lS8WizZuf': idToken, // Replace with your actual region and User Pool ID
        },
      });
  
      // Return a promise that resolves when credentials are ready
      return new Promise((resolve, reject) => {
        credentials.get((err) => {
          if (err) {
            reject(err);
          } else {
            resolve(credentials);
          }
        });
      });
    } catch (error) {
      console.error('Error initializing AWS credentials:', error);
      throw error;
    }
  };

  export default initAWSTemporaryCredentials